﻿// @ts-nocheck
// theme + stripe + tax + email settings

function saveTheme() {
  const select = document.getElementById("themeSelect");
  if (!select) return;
  const allowed = ["tiyb", "light", "dark", "ocean", "sunset"];
  const selected = allowed.includes(select.value) ? select.value : "tiyb";
  // Apply immediately for snappy UX
  document.documentElement.setAttribute("data-theme", selected);
  localStorage.setItem("tiyb-theme", selected);
  if (typeof window.__tiybUpdateThemeToggle === "function") {
    window.__tiybUpdateThemeToggle(selected);
  }
  // Persist to the company so all users in this company see it.
  const companyId = currentAuthUser?.companyId;
  if (!companyId) return;
  if (!canManageDataRole()) return; // members can't change company settings
  fetch("/api/admin/companies/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ id: companyId, theme: selected }),
  }).then(async (r) => {
    if (!r.ok) {
      const data = await r.json().catch(() => ({}));
      console.warn("Theme save failed:", data.error || r.status);
      return;
    }
    if (window.currentCompany) {
      window.currentCompany.theme = selected;
    }
  }).catch((e) => console.warn("Theme save error:", e));
}

function loadTheme() {
  const select = document.getElementById("themeSelect");
  const allowed = ["tiyb", "light", "dark", "ocean", "sunset"];
  // Authoritative source: company.theme (loaded from /api/auth/me).
  // Fallback: localStorage cache (for fast pre-paint and offline).
  const companyTheme = window.currentCompany?.theme;
  let theme = (companyTheme && allowed.includes(companyTheme))
    ? companyTheme
    : (localStorage.getItem("tiyb-theme") || "tiyb");
  if (!allowed.includes(theme)) {
    theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("tiyb-theme", theme);
  if (select) {
    select.value = theme;
    // Disable for users who can't manage company settings
    if (!canManageDataRole()) {
      select.disabled = true;
      select.title = "Only owners and admins can change the company theme.";
    }
  }
  if (typeof window.__tiybUpdateThemeToggle === "function") {
    window.__tiybUpdateThemeToggle(theme);
  }
}

async function saveBillingModel() {
  const select = document.getElementById("billingModelSelect");
  const status = document.getElementById("billingModelStatus");
  const companyId = currentAuthUser?.companyId;
  if (!select || !status || !companyId) return;
  if (!canManageDataRole()) {
    status.textContent = "Only owners and admins can change the billing model.";
    return;
  }

  const billingModel = select.value === "service_based" ? "service_based" : "hourly";
  const result = await fetchAdmin("/api/admin/companies/update", {
    method: "POST",
    body: JSON.stringify({ id: companyId, billingModel }),
  });
  if (!result.ok) {
    status.textContent = result.data.error || "Failed to save billing model";
    return;
  }

  if (window.currentCompany) {
    window.currentCompany.billingModel = billingModel;
  }
  applyRoleVisibility();
  status.textContent = "✓ Billing model saved";
  setTimeout(() => {
    status.textContent = "";
  }, 4000);
}

function loadBillingModel() {
  const select = document.getElementById("billingModelSelect");
  if (!select) return;
  const model = currentBillingModel();
  select.value = model;
  if (!canManageDataRole()) {
    select.disabled = true;
    select.title = "Only owners and admins can change the billing model.";
  }
}

async function saveStripeSettings() {
  if (!canManageBillingRole()) {
    alert("Only the company owner can update Stripe billing settings.");
    return;
  }

  const publishableKey = document.getElementById("stripePublishableKey").value.trim();
  const secretKey = document.getElementById("stripeSecretKey").value.trim();
  if (!publishableKey) {
    alert("Please enter your Stripe Publishable Key");
    return;
  }
  if (!secretKey) {
    alert("Please enter your Stripe Secret Key");
    return;
  }

  const result = await fetchAdmin("/api/settings/stripe", {
    method: "POST",
    body: JSON.stringify({ publishableKey, secretKey }),
  });
  if (!result.ok) {
    document.getElementById("stripeStatus").textContent = result.data.error || "Failed to save Stripe settings";
    return;
  }

  document.getElementById("stripeSecretKey").value = "";
  document.getElementById("stripeStatus").textContent = "✓ Stripe settings saved for this company";
  setTimeout(() => {
    document.getElementById("stripeStatus").textContent = "";
  }, 4000);
}

async function loadStripeSettings() {
  const result = await fetchAdmin("/api/settings/stripe");
  if (!result.ok) {
    document.getElementById("stripeStatus").textContent = "Failed to load Stripe settings";
    return;
  }

  const publishableKey = result.data.publishableKey || "";
  const hasSecretKey = Boolean(result.data.hasSecretKey);
  document.getElementById("stripePublishableKey").value = publishableKey;

  const statusText = hasSecretKey
    ? "Stripe secret key is configured for this company"
    : "Stripe secret key is not configured yet";
  document.getElementById("stripeStatus").textContent = statusText;
}

function parseTaxRatesTextarea(raw) {
  const out = {};
  const lines = String(raw || "").split(/\r?\n/);
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) continue;
    const parts = trimmed.split(":");
    if (parts.length < 2) continue;
    const state = parts[0].trim().toUpperCase();
    const rate = Number(parts.slice(1).join(":").trim());
    if (!US_STATE_CODES.includes(state)) continue;
    if (!Number.isFinite(rate) || rate < 0 || rate > 20) continue;
    out[state] = Number(rate.toFixed(4));
  }
  return out;
}

function formatTaxRatesTextarea(ratesByState) {
  return Object.entries(ratesByState || {})
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([state, rate]) => `${state}: ${rate}`)
    .join("\n");
}

function populateInvoiceStateSelect() {
  const select = document.getElementById("invoiceStateSelect");
  if (!select) return;
  const current = select.value;
  select.innerHTML = '<option value="">No tax</option>' + US_STATE_CODES
    .map((code) => `<option value="${code}">${code}</option>`)
    .join("");
  if (current && US_STATE_CODES.includes(current)) {
    select.value = current;
  } else if (taxRatesByState.TX !== undefined) {
    select.value = "TX";
  }
}

function setInvoiceStateFromProject(projectName) {
  const invoiceStateSelect = document.getElementById("invoiceStateSelect");
  if (!invoiceStateSelect || !projectName) return;
  const project = projects.find((p) => p.name === projectName);
  if (project?.clientState && US_STATE_CODES.includes(project.clientState)) {
    invoiceStateSelect.value = project.clientState;
  }
}

async function saveTaxSettings() {
  if (!isAdminUser()) {
    alert("Only admins can update tax settings.");
    return;
  }
  const textarea = document.getElementById("taxRatesByState");
  const status = document.getElementById("taxStatus");
  const ratesByState = parseTaxRatesTextarea(textarea?.value || "");
  const result = await fetchAdmin("/api/settings/tax", {
    method: "POST",
    body: JSON.stringify({ ratesByState }),
  });
  if (!result.ok) {
    status.textContent = result.data.error || "Failed to save tax settings";
    return;
  }
  taxRatesByState = result.data.ratesByState || {};
  if (textarea) textarea.value = formatTaxRatesTextarea(taxRatesByState);
  populateInvoiceStateSelect();
  status.textContent = "✓ Tax settings saved";
  setTimeout(() => { status.textContent = ""; }, 4000);
}

async function loadTaxSettings() {
  const textarea = document.getElementById("taxRatesByState");
  const status = document.getElementById("taxStatus");
  const result = await fetchAdmin("/api/settings/tax");
  if (!result.ok) {
    if (status) status.textContent = "Failed to load tax settings";
    return;
  }
  taxRatesByState = result.data.ratesByState || {};
  if (textarea) textarea.value = formatTaxRatesTextarea(taxRatesByState);
  populateInvoiceStateSelect();
}

function saveEmailSettings() {
  const fromEmail = document.getElementById("fromEmail").value.trim();

  if (fromEmail) {
    localStorage.setItem("fromEmail", fromEmail);
  } else {
    localStorage.removeItem("fromEmail");
  }
  // Legacy cleanup — TIYB no longer uses third-party email provider API keys.
  localStorage.removeItem("emailApiKey");

  document.getElementById("emailStatus").textContent = "✓ Saved";
  setTimeout(() => {
    document.getElementById("emailStatus").textContent = "";
  }, 3000);
}

function loadEmailSettings() {
  const fromEmail = localStorage.getItem("fromEmail");
  const fromInput = document.getElementById("fromEmail");
  if (fromInput && fromEmail) {
    fromInput.value = fromEmail;
  }
}
